import { ACTIONS_BY_ROLES } from "../../enums/actionsByRoles";

export const resolveContextActions = ({ roles = [], context, screen }) => {

  const contextConfig = ACTIONS_BY_ROLES[context];
  if (!contextConfig) return [];
  
  const screenConfig = contextConfig[screen];
  if (!screenConfig) return [];

  return Object.entries(screenConfig)
    .filter(([_, allowedRoles]) => 
      roles.some(role => allowedRoles.includes(role)) 
    ).map(([action, _]) => action); 
};
